import { lazy } from 'react';

const Notifications = lazy(() =>
  import('../../views/notifications/deliberate')
);
const ScheduledNotifications = lazy(() =>
  import('../../views/notifications/scheduled')
);

const NotificationsRoutes = [
  {
    path: '/notifications/deliberate',
    element: <Notifications />,
    meta: {
      permission: 'NOTIFICATION'
    }
  },
  {
    path: '/notifications/scheduled',
    element: <ScheduledNotifications />,
    meta: {
      permission: 'NOTIFICATION'
    }
  }
];

export default NotificationsRoutes;
